import { Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { CategoriesModalComponent } from '@form-field-module/modal-windows/categories-modal/categories-modal.component';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { SearchTicketsService } from '@sb-tools/typescript/services/search-tickets.service';
import { FormsModule, NgForm } from '@angular/forms';
import { UserService } from 'src/sb-tools/typescript/services/user.service';
import { UserDataService } from 'src/sb-tools/typescript/services/user-data.service';
import { FieldsSearchService } from '@sb-tools/typescript/services/fields-search.service';
import { FieldSearchModel } from '@sb-tools/typescript/models/field-search.model';
import { FormService } from 'src/sb-modules/Frontend-form-field-module/common/services/form.service';
import { first } from 'rxjs/internal/operators/first';
import { TagService } from '@sb-tools/typescript/services/tag.service';
import { CATEGORIES_MODAL_ID } from 'src/sb-tools/typescript/constants/nested-modal-ids';
import { TagsInputComponent } from '@form-field-module/tags-input/tags-input.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BsDatepickerInputDirective, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { TicketFolder } from '@sb-tools/typescript/enums/ticket-folder.enum';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { Sentiment } from '@sb-tools/typescript/enums/sentiment.enum';
import { TicketAssignStatus } from '@sb-tools/typescript/enums/ticket-assign-status.enum';
import { CreationDateFilter } from '@sb-tools/typescript/models/creation-date-filter.model';
import { TicketSourceSubtype } from '@sb-tools/typescript/enums/ticket-source-subtype.enum';
import { TicketsSearchRequest } from '../../../core/models/tickets-search-request.model';
import { getCategoryById } from '../../../core/utils/get-category-by-id.util';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { NgClass } from '@angular/common';
import { FocusDirective } from '../../../../sb-tools/typescript/directives/focus.directive';
import { TagsInputComponent as TagsInputComponent_1 } from '../../../../sb-modules/Frontend-form-field-module/tags-input/tags-input.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FiltersDropdownComponent } from '../../components/filters-dropdown/filters-dropdown.component';
import { FieldSearchItemComponent } from '../../components/field-search-item/field-search-item.component';
import { EnumToArrayPipe } from '../../../../sb-tools/typescript/pipes/enum-to-array.pipe';
import { TicketSourcePipe } from '../../../../sb-tools/typescript/pipes/ticket-source.pipe';
import { TicketSourceSubtypePipe } from '../../../../sb-tools/typescript/pipes/ticket-source-subtype.pipe';
import { SentimentPipe } from '../../pipes/sentiment.pipe';
import { CategoryFullNamePipe } from '../../pipes/category-full-name.pipe';
import { TicketStatusPipe } from '../../pipes/ticket-status.pipe';
import { AssignStatusPipe } from '../../pipes/assign-status.pipe';

@Component({
    selector: 'app-advanced-search-modal',
    templateUrl: './advanced-search-modal.component.html',
    styleUrls: ['./advanced-search-modal.component.scss'],
    imports: [
        TranslateModule,
        InlineSVGComponent,
        FormsModule,
        NgClass,
        FocusDirective,
        BsDatepickerModule,
        NgSelectComponent,
        NgOptionComponent,
        TagsInputComponent_1,
        TooltipModule,
        FiltersDropdownComponent,
        FieldSearchItemComponent,
        ModalModule,
        EnumToArrayPipe,
        TicketSourcePipe,
        TicketSourceSubtypePipe,
        SentimentPipe,
        CategoryFullNamePipe,
        TicketStatusPipe,
        AssignStatusPipe,
    ],
})
export class AdvancedSearchModalComponent implements OnDestroy, OnInit {
    @ViewChild('assignStatusSelect') assignStatusNgStatus: NgSelectComponent;
    @ViewChild('folderSelect') folderNgSelect: NgSelectComponent;
    @ViewChild('groupSelect') groupNgSelect: NgSelectComponent;
    @ViewChild('searchForm') form: NgForm;
    @ViewChild('sentimentSelect') sentimentNgSelect: NgSelectComponent;
    @ViewChild('sourceSelect') sourceNgSelect: NgSelectComponent;
    @ViewChild('sourceSubtypeSelect') sourceSubtypeNgSelect: NgSelectComponent;
    @ViewChild('statusSelect') statusNgSelect: NgSelectComponent;
    @ViewChildren('datepicker') datepickerList: QueryList<BsDatepickerInputDirective>;
    @ViewChildren(TagsInputComponent) tagsInputList: QueryList<TagsInputComponent>;

    addedFilters = {
        attachments: false,
        fields: false,
    };
    allFields: FieldSearchModel[] = [];
    assignedUsers = [];
    availableTicketSubTypes = {};
    closedByUsers = [];
    fieldsSearchItems = [];
    isFormSubmitted: boolean;
    isNeedSecondBackdrop = false;
    objectKeys = Object.keys;
    replyBy = {
        selectedUsers: [],
        searchUserText: '',
    };
    searchModel: TicketsSearchRequest;
    searchTags = [];
    selectedCategoriesList = [];
    sentimentEnum = Sentiment;
    ticketAssignStatusEnum = TicketAssignStatus;
    ticketFolderEnum = TicketFolder;
    ticketSourceEnum = TicketSource;
    ticketStatusEnum = TicketStatus;
    userGroups = [];
    users = [];

    private unsubscriber = new Subject<void>();

    constructor(
        public commonDataService: CommonDataService,
        public formService: FormService,
        public modalRef: BsModalRef,
        public tagService: TagService,
        private modalService: BsModalService,
        private translateService: TranslateService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
        private userDataService: UserDataService,
        private searchTicketsService: SearchTicketsService,
        private fieldsSearchService: FieldsSearchService,
    ) {}

    ngOnInit() {
        this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscriber)).subscribe((params) => {
            this.initSearchData(params);
        });

        this.searchTicketsService
            .getAvailableTicketSubTypes()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.availableTicketSubTypes = data;
            });

        this.searchTicketsService
            .getAvailableFields()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                data.forEach((field) => {
                    field.label = this.translateService.instant('Field value');
                    field.isRequired = true;
                    field.placeholder = '';
                    return field;
                });
                this.allFields = data;
            });

        this.userDataService
            .getUserGroups()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.userGroups = data;
            });
    }

    closeOpenedDropdowns() {
        this.datepickerList.forEach((datePicker) => {
            datePicker.hide();
        });
    }

    onChangeTicketType(isChecked, ticketType) {
        if (isChecked) {
            switch (ticketType) {
                case 'isOnlyHelperCategories':
                    this.searchModel.onlyMy = false;
                    this.searchModel.isAssignedToBot = false;
                    return;
                case 'onlyMy':
                    this.searchModel.isOnlyHelperCategories = false;
                    this.searchModel.isAssignedToBot = false;
                    return;
                case 'isAssignedToBot':
                    this.searchModel.onlyMy = false;
                    this.searchModel.isOnlyHelperCategories = false;
                    return;
            }
        }
    }

    cleanDependedFolderValues(field) {
        if (field === 'assignees') {
            this.searchModel.assignees = null;
            this.assignedUsers = [];
        } else if (field === 'closedBy') {
            this.searchModel.closedByAnyAgentFromGroup = null;
            this.closedByUsers = [];
        }
    }

    // todo: duplicated function with "Save search"
    openCategoriesModal() {
        this.isNeedSecondBackdrop = true;

        const initialState = {
            modalId: CATEGORIES_MODAL_ID,
            isPrivate: false,
            ignoreDeactivate: true,
            isDisableRemoving: true,
            onChangeCategory: (newCategory) => {
                this.addCategoryToList(newCategory);
            },
            selectedCategoryIds: this.selectedCategoriesList.map((c) => c.id),
        };

        this.modalService.show(CategoriesModalComponent, {
            initialState,
            id: CATEGORIES_MODAL_ID,
        });

        this.modalService.onHide.pipe(takeUntil(this.unsubscriber)).subscribe(() => {
            this.isNeedSecondBackdrop = false;
        });
    }

    addCategoryToList(selectedCategory) {
        if (selectedCategory) {
            if (
                !this.selectedCategoriesList.some((category) => {
                    return category.id === selectedCategory.id;
                })
            ) {
                this.selectedCategoriesList.push(selectedCategory);
            }
        }
    }

    removeCategoryFromList(index: number) {
        this.selectedCategoriesList.splice(index, 1);
    }

    initSearchData(searchParams) {
        this.initSearchModel(searchParams);

        this.initTags();

        this.initCategories();

        if (this.searchModel.fields) {
            this.addedFilters.fields = true;
            this.fieldsSearchItems = this.fieldsSearchService.getDecodedValue(this.searchModel.fields as string);
        }

        if (this.searchModel.hasAttachments) {
            this.addedFilters.attachments = true;
        }

        this.userService
            .getAll()
            .pipe(first())
            .subscribe((data) => {
                data.forEach((user) => {
                    user.label = user.name ? user.name + ' ' + user.email : user.email;
                });

                this.users = data;

                if (this.searchModel.repliedBy) {
                    const replyByIds: string[] = searchParams.repliedBy.split(',');
                    this.replyBy.selectedUsers = this.users.filter((user) => {
                        return replyByIds.includes(user.id);
                    });
                }

                if (this.searchModel.closedByAgent) {
                    this.closedByUsers = this.users.filter((user) => {
                        return user.id === searchParams.closedByAgent;
                    });
                }

                if (this.searchModel.assignees) {
                    const assigneesIds: string[] = searchParams.assignees.split(',');
                    this.assignedUsers = this.users.filter((user) => {
                        return assigneesIds.includes(user.id);
                    });
                }
            });
    }

    search() {
        this.isFormSubmitted = true;
        this.formService.isSubmitted = true;

        if (this.form.valid && this.checkFieldsValidation(this.form.controls)) {
            if (this.searchModel.toDate) {
                this.searchModel.toDate.setHours(23, 59, 59);
            } else {
                this.searchModel.toDate = null;
            }

            if (this.searchModel.replyToDate) {
                this.searchModel.replyToDate.setHours(23, 59, 59);
            } else {
                this.searchModel.replyToDate = null;
            }

            if (this.searchModel.fromDate) {
                this.searchModel.fromDate.setHours(0, 0, 0);
            } else {
                this.searchModel.fromDate = null;
            }

            if (this.searchModel.replyFromDate) {
                this.searchModel.replyFromDate.setHours(0, 0, 0);
            } else {
                this.searchModel.replyFromDate = null;
            }

            const newParams: any = {};

            const closedByUsersIds = this.closedByUsers.map((u) => u.id);
            const assigneeUsersIds = this.assignedUsers.map((u) => u.id);

            newParams.folder =
                (this.searchModel.folder as any) === TicketFolder.notArchived || this.searchModel.folder === null
                    ? null
                    : this.searchModel.folder;
            newParams.status =
                (this.searchModel.status as any) === TicketStatus.all || this.searchModel.status === null
                    ? null
                    : this.searchModel.status;
            newParams.sentiment =
                (this.searchModel.sentiment as any) === Sentiment.all || this.searchModel.sentiment === null
                    ? null
                    : this.searchModel.sentiment;
            newParams.source =
                (this.searchModel.source as any) === TicketSource.all || this.searchModel.source === null
                    ? null
                    : this.searchModel.source;
            newParams.sourceSubtype =
                (this.searchModel.sourceSubtype as any) === TicketSourceSubtype.none ||
                this.searchModel.sourceSubtype === null
                    ? null
                    : this.searchModel.sourceSubtype;
            newParams.usersQuery = this.searchModel.usersQuery;
            newParams.threadQuery = this.searchModel.threadQuery;
            newParams.fieldsQuery = this.searchModel.fieldsQuery;
            newParams.fromDate = this.searchModel.fromDate ? this.searchModel.fromDate.toISOString() : null;
            newParams.toDate = this.searchModel.toDate ? this.searchModel.toDate.toISOString() : null;
            newParams.replyFromDate = this.searchModel.replyFromDate
                ? this.searchModel.replyFromDate.toISOString()
                : null;
            newParams.replyToDate = this.searchModel.replyToDate ? this.searchModel.replyToDate.toISOString() : null;
            newParams.hasAttachments = this.searchModel.hasAttachments || null;
            newParams.hasNoReplyFromTeam = this.searchModel.hasNoReplyFromTeam || null;
            newParams.withoutCategory = this.searchModel.withoutCategory === true || null;
            newParams.onlyMy = this.searchModel.onlyMy;
            newParams.isOnlyHelperCategories = this.searchModel.isOnlyHelperCategories || null;
            newParams.isAssignedToBot = this.searchModel.isAssignedToBot || null;
            newParams.repliedBy = this.replyBy.selectedUsers.map((u) => u.id).join(',') || null;
            newParams.tagIds = this.searchTags.map((t) => t.id).join(',') || null;
            newParams.fields = this.fieldsSearchService.getEncodedValueFromControls(this.form.controls) || null;
            newParams.categoryIds = this.selectedCategoriesList.map((c) => c.id).join(',') || null;
            newParams.lastUpdateDaysDuration = this.searchModel.lastUpdateDaysDuration;
            newParams.closedByAnyAgentFromGroup = this.searchModel.closedByAnyAgentFromGroup;
            newParams.closedByAgent = closedByUsersIds.length ? closedByUsersIds[0] : null;
            newParams.assignees = assigneeUsersIds.join(',') || null;
            newParams.isAssigned =
                this.searchModel.isAssigned === TicketAssignStatus.all || this.searchModel.isAssigned === null
                    ? null
                    : this.searchModel.isAssigned === TicketAssignStatus.assigned;
            this.modalRef.hide();

            this.router.navigate([], {
                relativeTo: this.activatedRoute,
                queryParams: newParams,
            });
        }
    }

    addFilter(type) {
        switch (type) {
            case 'fields': {
                this.fieldsSearchItems.push({ key: null, value: '' });
                this.addedFilters[type] = true;
                return;
            }
            case 'attachments': {
                this.addedFilters[type] = true;
                this.searchModel.hasAttachments = true;
            }
        }
    }

    removeFilter(type, index?) {
        switch (type) {
            case 'fields': {
                this.fieldsSearchItems.splice(index, 1);
                return;
            }
            case 'attachments': {
                this.addedFilters[type] = false;
                this.searchModel.hasAttachments = null;
            }
        }
    }

    reset() {
        this.initSearchModel({
            status: TicketStatus.open,
            onlyMy: this.commonDataService.isOnlyMyTicketsFilterDefault,
        });

        this.assignedUsers = [];
        this.closedByUsers = [];
        this.selectedCategoriesList = [];
        this.fieldsSearchItems = [];
        this.searchTags = [];
        this.addedFilters = {
            attachments: false,
            fields: false,
        };
        this.replyBy = {
            selectedUsers: [],
            searchUserText: '',
        };

        this.tagsInputList.forEach((inputComponent) => {
            inputComponent.selectedText = '';
        });
    }

    private checkFieldsValidation(controls) {
        if (!this.addedFilters.fields) {
            return true;
        } else {
            return this.fieldsSearchService.checkValidation(controls);
        }
    }

    private initCategories() {
        this.selectedCategoriesList.length = 0;
        const ids: [] =
            this.searchModel.categoryIds && this.searchModel.categoryIds.length > 0
                ? this.searchModel.categoryIds.split(',')
                : [];

        ids.forEach((id) => {
            const category = getCategoryById(this.commonDataService.categories.all, id);
            if (category) {
                this.selectedCategoriesList.push(category);
            }
        });
    }

    private initSearchModel(searchParams) {
        this.searchModel = {
            usersQuery: searchParams.usersQuery,
            threadQuery: searchParams.threadQuery,
            fieldsQuery: searchParams.fieldsQuery,
            categoryIds: searchParams.categoryIds,
            // count: this.count,
            // skip: this.skip,
            folder: searchParams.folder ? +searchParams.folder : TicketFolder.notArchived, // All
            sentiment: searchParams.sentiment ? +searchParams.sentiment : Sentiment.all,
            source: searchParams.source ? searchParams.source : TicketSource.all,
            status: searchParams.status ? +searchParams.status : TicketStatus.all,
            tagIds: searchParams.tagIds,
            fields: searchParams.fields,
            orderBy: searchParams.orderBy,
            // adminView: this.commonDataService.showAllTickets || false,
            fromDate: searchParams.fromDate ? new Date(searchParams.fromDate) : null,
            toDate: searchParams.toDate ? new Date(searchParams.toDate) : null,
            replyFromDate: searchParams.replyFromDate ? new Date(searchParams.replyFromDate) : null,
            replyToDate: searchParams.replyToDate ? new Date(searchParams.replyToDate) : null,
            hasAttachments: searchParams.hasAttachments === 'true',
            hasNoReplyFromTeam: searchParams.hasNoReplyFromTeam === 'true' ? true : null,
            withoutCategory: searchParams.withoutCategory === 'true',
            // adminView: searchParams.adminView, // == 'true',
            onlyMy: searchParams.onlyMy === 'true',
            isOnlyHelperCategories: searchParams.isOnlyHelperCategories === 'true',
            isAssignedToBot: searchParams.isAssignedToBot === 'true',
            sourceSubtype: searchParams.sourceSubtype ? +searchParams.sourceSubtype : TicketSourceSubtype.none, // All
            lastUpdateDaysDuration: searchParams.lastUpdateDaysDuration,
            closedByAnyAgentFromGroup: searchParams.closedByAnyAgentFromGroup
                ? +searchParams.closedByAnyAgentFromGroup
                : searchParams.closedByAnyAgentFromGroup,
            closedByAgent: searchParams.closedByAgent,
            assignees: searchParams.assignees,
            repliedBy: searchParams.repliedBy,
            isAssigned: this.getIsAssignedStatus(searchParams.isAssigned),
            creationDateFilter: new CreationDateFilter(),
        } as any;
        // todo: remove 'as any';

        if (searchParams.isAssigned === undefined) {
            this.searchModel.isAssigned = TicketAssignStatus.all;
        } else {
            if (searchParams.isAssigned === 'true') {
                this.searchModel.isAssigned = TicketAssignStatus.assigned;
            } else {
                this.searchModel.isAssigned = TicketAssignStatus.unassigned;
            }
        }
    }

    private getIsAssignedStatus(isAssigned: string): TicketAssignStatus {
        if (isAssigned === undefined) {
            return TicketAssignStatus.all;
        } else {
            if (isAssigned === 'true') {
                return TicketAssignStatus.assigned;
            } else {
                return TicketAssignStatus.unassigned;
            }
        }
    }

    private initTags(): void {
        const ids =
            this.searchModel.tagIds && this.searchModel.tagIds.length > 0 ? this.searchModel.tagIds.split(',') : [];
        this.searchTags = this.tagService.allTags.filter((tag) => {
            return ids.includes(tag.id);
        });
    }

    ngOnDestroy(): void {
        this.formService.isSubmitted = false;
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
